module.exports = __webpack_public_path__ + "img/设备运维5.ddcf533e.png";